import { createFileRoute } from "@tanstack/react-router";

import { SharedView } from "@/components/share/shared-view";
import { buildShareHead } from "@/lib/shared-og";
import { getSharedResource, type SharedResource } from "@/lib/boide-api";

type ShareLoaderData = { resource: SharedResource | null; token: string };

export const Route = createFileRoute("/q/$token")({
  loader: async ({ params }): Promise<ShareLoaderData> => {
    try {
      const resource = await getSharedResource(params.token);
      return { resource, token: params.token };
    } catch {
      return { resource: null, token: params.token };
    }
  },
  head: ({ loaderData }) => buildShareHead(loaderData?.resource ?? null, loaderData?.token ?? ""),
  component: QSharePage,
});

function QSharePage() {
  const { resource, token } = Route.useLoaderData();
  return <SharedView resource={resource} token={token} />;
}
